import { render, staticRenderFns } from "./DoorCard.vue?vue&type=template&id=6d0258ea&scoped=true&"
import script from "./DoorCard.vue?vue&type=script&lang=js&"
export * from "./DoorCard.vue?vue&type=script&lang=js&"
import style0 from "./DoorCard.vue?vue&type=style&index=0&id=6d0258ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0258ea",
  null
  
)

export default component.exports